import TableVM from '../table-vm';
export default Kadenze.Util.extendObj(TableVM, function(student_id) {
  var self = this;
  self.$el = $('#summary-tab-content');
  self.request_pool = new Kadenze.AjaxRequestPool();
  self.student_id = ko.observable();
  self.student = ko.observable();

  self.initUI = function() {

  };

  self.filterChanged = function () {
    self.$el.click(); //Hack to close selectpicker & menus
    self.request_pool.abortAll();
    self.showPlaceholder('loading');
    self.getStudent();
  };

  self.getStudent = function() {
    var url = Kadenze.Routes.show_course_gradebook_summary_index_path(self.course_id, self.student_id());

    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      data: null,
      timeout: 60000,
      beforeSend: function (xhr, settings) {
        self.request_pool.add(xhr);
      }
    });

    request.done(function(data) {
      var mapped_student = ko.mapping.fromJS(data.student);
      self.student(mapped_student);

      self.hidePlaceholder();
    });

    request.fail(function(xhr, textStatus, message) {
      if (textStatus == 'abort') {
        return;
      }
      console.log('Error retrieving row data:', xhr);
    });
  };

  self.exportTable = function () {
    var url = Kadenze.Routes.export_course_gradebook_summary_index_path(self.course_id, {student_id: self.student_id()});
    window.open(url, '_blank');
    Kadenze.Analytics.track('grade', 'download', {type: 'student_summary'});
  };

  const __construct = function(that) {
    console.log('constructor called for InstructorGradebook.Student.SummaryVM');
    that.course_id = $('#course_id').val();

    that.student_id.subscribe(that.filterChanged);
    that.student_id(student_id);
  }(this);
});

